"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _publication = require("../common/utils/publication");
var setup = function setup(_ref) {
  var latestAsset = _ref.latestAsset;
  return {
    description: 'Add a URL that describes the structure of a HTTP API.',
    flows: [{
      fields: [(0, _publication.apiVersionField)(latestAsset)]
    }]
  };
};
var _default = exports.default = setup;
//# sourceMappingURL=form.js.map